module.exports = __webpack_public_path__ + "static/media/9.eaa1804a.jpg";